module.exports = __webpack_public_path__ + "summernote.6e72b5d181d3c1793e71.eot";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/summernote/summernote.eot?e557617934c52ea068954af79ed7c221
// module id = ../../../../../src/assets/vendors/base/fonts/summernote/summernote.eot?e557617934c52ea068954af79ed7c221
// module chunks = styles